<template>
  <div class="f-v f-gap-12 m-bx3">
    <iframe
      v-for="(albumId, i) in albumIds"
      :key="i"
      style="border-radius:12px" 
      :src="`https://open.spotify.com/embed/album/${albumId}?utm_source=generator`" 
      width="100%" 
      height="352" 
      frameBorder="0" 
      allowfullscreen="" 
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" 
      loading="lazy"
    ></iframe>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        albumIds: [
          "3pjUze7GryCqVcmOQrpT9T", // Goblin Exile
          "2LHKpAriKKMawUFSnmJSqP", // Whale Song
          "5rSM1VJujKNosqF0eVFkDS", // The Curse of the Jersey Devil
          "1HveBoKVbfDMp27WU7iqZb", // Still Lazy After All These Beers
        ]
      }
    },
  };
</script>
